// extracted by mini-css-extract-plugin
export default {"mainContent":"KitDishesExtended_mainContent__BiOiy","mainTable":"KitDishesExtended_mainTable__EWdvb","placeHolderShimmer":"KitDishesExtended_placeHolderShimmer__D06Vb"};